import { Button, Icon, Stack, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import OTPInput from "react-otp-input";
import { toEnglishDigits } from "../../../../utils/language";
import { useTimeParser } from "../../hooks/useTimeParser";

type TProps = {
    validateOtpCode: (otpCode: string) => void;
    sendOtpCodeAgain: (otpCode: string) => void;
    stepBack: () => void;
    isLoading: boolean;
};

export default function OptStep(props: TProps) {
    const theme = useTheme();
    const [otpCode, setOtpCode] = useState<string>("");

    const { coolDown, reset } = useTimeParser();

    const handleSendOtpCode = () => {
        props.validateOtpCode(otpCode);
    };

    const handleChangeOtpCode = (otpCode: string) => {
        setOtpCode(toEnglishDigits(otpCode));
    };

    const handleSendOtpCodeAgain = () => {
        reset();
        props.sendOtpCodeAgain(otpCode);
    };

    return (
        <>
            <Typography>لطفا کد ارسال شده را وارد کنید</Typography>

            <Typography component="span" sx={{ alignSelf: "center" }}>
                {coolDown} ثانیه
            </Typography>
            <Stack gap={2}>
                <OTPInput
                    value={otpCode}
                    onChange={handleChangeOtpCode}
                    numInputs={4}
                    renderSeparator={<span>-</span>}
                    containerStyle={{
                        flexDirection: "row-reverse",
                    }}
                    inputStyle={{
                        width: "40px",
                        height: "40px",
                        margin: "0 4px",
                        fontSize: "20px",
                        border: "1px solid #000",
                        borderRadius: "4px",
                        textAlign: "center",
                        outline: `1px solid ${theme.palette.primary.main}`,
                    }}
                    renderInput={(props) => <input {...props} />}
                />

                <Button
                    sx={{ width: "fit-content", alignSelf: "center" }}
                    variant="text"
                    onClick={handleSendOtpCodeAgain}
                >
                    ارسال مجدد کد
                </Button>

                <Stack direction="row" gap={2}>
                    <Button
                        variant="outlined"
                        onClick={props.stepBack}
                        sx={{ flex: 1 }}
                    >
                        بازگشت
                    </Button>

                    <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        onClick={handleSendOtpCode}
                        disabled={props.isLoading}
                        endIcon={<Icon>arrow_back</Icon>}
                        sx={{ py: 1.5 }}
                    >
                        {props.isLoading ? "در حال تایید..." : "تایید کد"}
                    </Button>
                </Stack>
            </Stack>
        </>
    );
}
